


// document.addEventListener("DOMContentLoaded", function() {
//   var endlessClick = new Ajaxinate({
//     method: 'click';
//   });
// });


document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination'
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var endlessClick = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '#AjaxinatePagination',
    method: 'click'
  });
});

$(function(){
//   $('#footer-current-locale').click(function(){
//     $('#footer-slidedown-wrapper').slideToggle();
//   });
});





function resizeGridItem(item){
  jstacker = document.getElementsByClassName("j-stacker")[0];
  rowHeight = parseInt(window.getComputedStyle(jstacker).getPropertyValue('grid-auto-rows'));
  rowGap = parseInt(window.getComputedStyle(jstacker).getPropertyValue('grid-row-gap'));
  rowSpan = Math.ceil((item.querySelector('.j-column-item').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
  item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
  allItems = document.getElementsByClassName("item");
  for(x=0;x<allItems.length;x++){
    resizeGridItem(allItems[x]);
  }
}

function resizeInstance(instance){
  item = instance.elements[0];
  resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);

allItems = document.getElementsByClassName("item");
for(x=0;x<allItems.length;x++){
  imagesLoaded( allItems[x], resizeInstance);
}

$(function(){
  $('.order-comment').click(function(e){
    e.preventDefault();
    $('.cart-info-text').slideToggle();
  });
});

// SEARCH DESKTOP
$(document).ready(function() {
  //trigger on type
  $('.clear').css('display', 'none');
  $('.search-box').keyup(function() {
    var empty = false;
    var value = $(this).val().toLowerCase();

    //Assign search input empty value
    $('.search-box').each(function() {
      if ($(this).val().length == 0) {
        empty = true;
      }
    });

    //If no input
    if (empty) {
      $('.search-result').css('display', 'none');
      $('.clear').css('display', 'none');
    }//Has input
    else {
      $('.search-result').css('display', 'block');
      $('.clear').css('display', 'block');
      $(".search-result .with-text").filter(function() {
        var booleanValue = $(this).text().toLowerCase().indexOf(value) > -1;
        if(booleanValue == true) {
          $(this).toggle(booleanValue);
          $(this).addClass('visible');   
        } else {
          $(this).hide();
          $(this).removeClass('visible');
        }
      });
      $('.search-string-text').text(value)
    }

    // FOR 0 SEARCH RESULT
    var array = [];
    $('#search-prod-list .visible').slice(0,10).each(function(i) {
      var sTitle = $(this).find('.prod-title').data('title'),
          sUrl = $(this).find('a').data('produrl'),
          sImg = $(this).find('a').data('imgsrc1'),
          sType = $(this).find('a').data('type'),
          sDesc = $(this).find('a').data('description'),
          sCollection = $(this).find('.prod-collection').data('prodcollection')
      array.push({
        title: sTitle,
        image: sImg,
        url: sUrl,
        type: sType,
        description: sDesc,
        collection: sCollection
      });

    });
    var searchedCookies = JSON.stringify(array);
    var searchedC = Cookies.get('zeroresults');

    if(searchedC != undefined){
      Cookies.remove('zeroresults');
      Cookies.set('zeroresults', searchedCookies);
    }else{
      Cookies.set('zeroresults', searchedCookies);
    }

//     LIMIT SHOW PRODUCT
    var numberofProducts = $('#search-prod-list .visible').length
    if (numberofProducts > 10) {
      $('#search-prod-list .visible').slice(10).css( "display", "none" );
      $('#search-article-list .visible').css( "display", "none" );

    } else{
      var maxnumb = 10,
          slicenum = maxnumb - numberofProducts;
      $('#search-article-list .visible').slice(slicenum).css( "display", "none" );
    }
    
//     SHOW ALL PRODUCTS
    $('.sr-sh').click(function(e){
      $('#search-prod-list .visible').slice(0).css( "display", "block" );
    })

    var numberOfItems = $('.search-result .visible').length;

    if (numberOfItems == 0) {
      $('.search-result .nothing-text').css('display', 'block');
      $('#sr-count').hide();
      $('.sr-sh-btn').hide();
    }
    else {
      $('.search-result .nothing-text').css('display', 'none');
      $('#sr-count').show();
      $('.sr-sh-btn').show();
      $('#sr-count .sr-ct').text(numberOfItems)
    }
  });

  $('.clear').click(function(){
    $('.search-box').val('');
    $('.search-result').css('display', 'none');
    $('.clear').css('display', 'none');
  });
});
// END SEARCH DESKTOP



// SEARCH MOBILE
$(document).ready(function() {
  //trigger on type
  $('.search-box2').keyup(function() {
    var empty = false;
    var value = $(this).val().toLowerCase();
    //Assign search input empty value
    $('.search-box2').each(function() {
      if ($(this).val().length == 0) {
        empty = true;
      }
    });

    //If no input
    if (empty) {
      $('.search-result').css('display', 'none');
    }//Has input
    else {
      $('.search-result').css('display', 'block');
      $(".search-result .with-text").filter(function() {
        var booleanValue = $(this).text().toLowerCase().indexOf(value) > -1;
        if(booleanValue == true) {
          $(this).toggle(booleanValue);
          $(this).addClass('visible');
        } else {
          $(this).hide();
          $(this).removeClass('visible');
        }
      });
      $('.search-string-text').text(value)
    }

    //     LIMIT SHOW PRODUCT
    var numberofProducts = $('#search-prod-list .visible').length;
    if (numberofProducts > 10) {
      $('#search-prod-list .visible').slice(10).css( "display", "none" );
      $('#search-article-list .visible').css( "display", "none" );
    } else{
      var maxnumb = 10,
          slicenum = maxnumb - numberofProducts;
      $('#search-article-list .visible').slice(slicenum).css( "display", "none" );
    }

    var numberOfItems = $('.search-result .visible').length;
    if (numberOfItems == 0) {
      $('.search-result .nothing-text').css('display', 'block');
    }
    else {
      $('.search-result .nothing-text').css('display', 'none');
      $('.sr-sh-btn').show();
    }
  });

  $('.clear2').click(function(){
    $('.search-box2').val('');
    $('.search-result').css('display', 'none');
    $('.hdr-search-mobile').hide();
  });
});
// END SEARCH MOBILE


// SEARCH INGREDIENTS
$(document).ready(function() {
  //trigger on type
  $('.ingridient-searchText').keyup(function() {
    var empty = false;
    var value = $(this).val().toLowerCase();
    //Assign search input empty value
    $('.ingridient-searchText').each(function() {
      if ($(this).val().length == 0) {
        empty = true;
      }
    });

    //If no input
    if (empty) {
      $('.search-ingredients-result').css('display', 'none');
    }//Has input
    else {
      $('.search-ingredient-clear').css('display', 'block');
      $('.search-ingredients-result').css('display', 'block');
      $(".search-ingredients-result .with-text").filter(function() {
        var booleanValue = $(this).text().toLowerCase().indexOf(value) > -1;
        if(booleanValue == true) {
          $(this).toggle(booleanValue);
          $(this).addClass('visible');
        } else {
          $(this).hide();
          $(this).removeClass('visible');
        }
      });
      $('.ingredient-search-string-text').text(value)
    }
    
//     LIMIT SHOW PRODUCT
    var numberofProducts = $('#search-ingredient-list .visible').length;
    if (numberofProducts > 10) {
      $('#search-ingredient-list .visible').slice(10).css( "display", "none" );
    }
    
    var numberOfItems = $('#search-ingredient-list .visible').length;
    if (numberOfItems == 0) {
      $('#search-ingredient-list .nothing-text').css('display', 'block');
    }
    else {
      $('#search-ingredient-list .nothing-text').css('display', 'none');
    }
    
  });

  $('.search-ingredient-clear').click(function(){
    $('.ingridient-searchText').val('');
    $('.search-ingredients-result').css('display', 'none');
    $('.search-ingredient-clear').css('display', 'none');
  });
});
// END SEARCH INGREDIENTS


// SEARCH STORIES
$(document).ready(function() {
  //trigger on type
  $('.story-searchText').keyup(function() {
    var empty = false;
    var value = $(this).val().toLowerCase();
    //Assign search input empty value
    $('.story-searchText').each(function() {
      if ($(this).val().length == 0) {
        empty = true;
      }
    });

    //If no input
    if (empty) {
      $('.search-stories-result').css('display', 'none');
    }//Has input
    else {
      $('.search-stories-clear').css('display', 'block');
      $('.search-stories-result').css('display', 'block');
      $(".search-stories-result .with-text").filter(function() {
        var booleanValue = $(this).text().toLowerCase().indexOf(value) > -1;
        if(booleanValue == true) {
          $(this).toggle(booleanValue);
          $(this).addClass('visible');
        } else {
          $(this).hide();
          $(this).removeClass('visible');
        }
      });
      $('.stories-search-string-text').text(value)
    }

    // FOR 0 SEARCH STORIES RESULT
    var arrayStories = [];
    $('#search-stories-list .visible').slice(0,10).each(function(i) {
      var sTitle = $(this).find('.arcticle-title').data('title'),
          sUrl = $(this).find('a').data('storyurl'),
          sImg = $(this).find('a').data('storyimg1')
      arrayStories.push({
        title: sTitle,
        image: sImg,
        url: sUrl
      });
    });

    var searchedStoryCookies = JSON.stringify(arrayStories);
    var searchedStoryC = Cookies.get('zerostoryresults');

    if(searchedStoryC != undefined){
      Cookies.remove('zerostoryresults');
      Cookies.set('zerostoryresults', searchedStoryCookies);
    }else{
      Cookies.set('zerostoryresults', searchedStoryCookies);
    }


    //     LIMIT SHOW PRODUCT
    var numberofProducts = $('#search-stories-list .visible').length;
    
    if (numberofProducts > 10) {
      $('#search-stories-list .visible').slice(10).css( "display", "none" );
    }

    var numberOfItems = $('#search-stories-list .visible').length;
    if (numberOfItems == 0) {
      $('#search-stories-list .nothing-text').css('display', 'block');
    }
    else {
      $('#search-stories-list .nothing-text').css('display', 'none');
    }

  });

  // $('.search-stories-clear').click(function(){
  //   $('.stories-searchText').val('');
  //   $('.search-stories-result').css('display', 'none');
  //   $('.search-stories-clear').css('display', 'none');
  // });
});
// END SEARCH STORIES

$(document).ready(function(){
  
  // login
  $('.userlogin').click(function(e){
    e.preventDefault();
    $(".mini-login-box").toggle();
    $('.mini-cart-content').hide();
  });

  // close
  $('.svg-close').click(function(){
    $(".mini-login-box").toggle();
  });

  // mini-cart-close
  $('.mini-cart-close').click(function(e){
    e.preventDefault();
    $('.mini-cart-content').hide();
  });

  // basket
  $('.mini-cart-total').click(function(e){
    e.preventDefault();
    $('.mini-cart-content').toggle();
    $('.mini-login-box').hide();
  });
  

//   HIDE SUGGESTED PRODUCT IN BLOG
  
  if($('body').hasClass('template-blog')){

    $('.bc-sf-search-suggestion').css({'visibilty':'hidden','opacity':'0'});
    $('#ui-id-3').css({"visibility":"hidden","opacity":"0"})
  }
  
  if($('body').hasClass('template-search')){

    $('.bc-sf-search-suggestion').css({'visibilty':'hidden','opacity':'0'});
    $('#ui-id-3').css({"visibility":"hidden","opacity":"0"})
    
//     SHOW PREDICTIVE PRODUCT IF ZERO RESULT
    if($('.search-section').hasClass('no-results')){
      var searchedCookies = Cookies.get('zeroresults');
      console.log(searchedCookies)
      if(searchedCookies != undefined && searchedCookies != "[]"){
        
        $('.searched-collection-wrapper').prepend('<h2 class="nr-header">Were you looking for:</h2>')
        var thisItems = JSON.parse(searchedCookies)
        for(var i = 0; i < thisItems.length; i++){
            var searchedItems = '<div class="collection-card">'+
                '<div class="product-image">'+
                '<a href='+ thisItems[i].url +'>'+
                '<img class="first-image" src='+ thisItems[i].image+ '>'+
                '</a>'+
                '</div>'+
                '<div class="product-type">'+
                '<p>'+ thisItems[i].type +'</p>'+
                  '</div>'+
                '<div class="product-name">'+
                  '<a href='+ thisItems[i].url +'>'+thisItems[i].title+'</a>'+
                  '</div>'+
                '<div class="product-description">'+
                  '<p>'+ thisItems[i].description +'</p>'+
                  '</div>'+
                  '</div>'
            $('.searched-collection-wrapper').find('.searched-collection-itemslist').append(searchedItems);
          Cookies.remove('zeroresults')
        }
      }
    }else{
      
    }
//     SHOW PREDICTIVE SEARCH STORIES IF ZERO RESULT
    if($('.stories-searched-section').hasClass('no-story-result')){
      $('.section-header.text-center').hide();
      var searchedStoryCookies = Cookies.get('zerostoryresults');
      if(searchedStoryCookies != undefined){
        $('.searched-story-list').prepend('<h2 class="nr-header" style="width: 100%;"></h2>')
        var thisItems = JSON.parse(searchedStoryCookies)
        for(var i = 0; i < thisItems.length; i++){
          var searchedItems = '<div class="st-1">' +
              '<a href=" thisItems[i].url">' +
              '<div class="story-image">' +
              '<img src='+ thisItems[i].image+'>'+
              '</div>'+
              '<div class="story-desc">'+
              '<span>'+thisItems[i].title+'</span>'+
              '</div>'+
              '<div class="read-story">'+
              '<span>Read story</span>'+
              '</div>'+
              '<div id="img-overlay" class="img-overlay"></div>'+
              '</a>'+
              '</div>' 
          $('.searched-story-list').append(searchedItems);
          Cookies.remove('zerostoryresults')
        }
      }
    }

  
  }



  // bar
//   $('.hdr-selector').click(function(){
//     $(this).toggleClass("change");
//     $('.h-nav-wrapper').toggleClass("nav-open");
//     $('.header-wrapper').toggleClass("header-open");
//     $('.h-sub-nav').removeClass("active").removeClass("notactive");
//     $('.h-sub-nav > li').removeClass("not-active-sub").removeClass("active-sub");

//   });

//   var $zoom = $('#zoom_01');
//   $zoom.elevateZoom({
//     cursor:"crosshair"
//   });

  //   SWITCH imAGE
//   $('.MagicThumbTinyPreview').click(function(e){
//     e.preventDefault();

//     $('.changeimg').fadeOut("slow");
//     $('.changeimg').fadeIn("slow");
//     $('.changeimg').attr('src',this.src);
//     $zoom.data('zoom-image',this.src).elevateZoom({
//       cursor:"pointer"

//     });
//   });
 

  // faq footer links shipping
  $('.accordion__shelf-title').click(function(){
    var $this = $(this),
        subcont = $this.siblings('.accordion__shelf-body');
    subcont.slideToggle(400);

  })

  // forgetpass OVERLAY
  $('#RecoverPassword, .recover-password, .faq-resetpass').click(function(e){
    e.preventDefault();
    $('.modal-overlay').show();
  });

  //forgetpass mobile overlay
  $('#RecoverPassword-mbl').click(function(e){
    e.preventDefault();
    $('.modal-overlay').show();
  });
  

  $('.modal-close-button').click(function(){
    $('.modal-overlay').hide();
  });

  //account login/reg
//   $('.signuptab').click(function(e){
//     e.preventDefault();
//     $('form#customer_login').hide();
//     $('#create_customer').show();
//   });
  


  // SUB NAVIGATION
  $('.h-main-nav .main-nav-list > a').click(function(e) {
    if ($(window).width() < 835) {
      var $this = $(this);
      var $parent = $this.parent();
      if($this.siblings('.h-sub-nav')){
        e.preventDefault()
        $('.h-nav-wrapper').animate({
          scrollTop: $(".h-nav-wrapper").offsetTop - 50

        }, 1000)
        
        $('.subnav-mbl > a').unbind('click');
      }
      // e.preventDefault();
      $parent.children('.h-sub-nav').addClass("active").removeClass("notactive")
      .children('.h-sub-nav > li').addClass("active-sub").removeClass("not-active-sub").children('a').addClass("active-sub-a")
    }
  });
  
  //   DISABLE PREVENT DEFAULT MAIN NAV LI
//   $('.h-main-nav > li > a').click(function(e){
//      $('.subnav-mbl > a').unbind('click');
//   });

	
//   DISABLE SEARCH WHEN EMPTY
  
      $('.search-bar__submit').attr('disabled',true);
      $('.search__input').keyup(function(){
          if($(this).val().length !=0)
              $('.search-bar__submit').attr('disabled', false);            
          else
              $('.search-bar__submit').attr('disabled',true);
      });

      $('.btn--link').click(function(){
        $(this).closest('.search-bar__form')
      });
 
  
//   PAGINATE RELATED ITEMS IN INGREDIENTS
  var maxH = 352;
  $('#paginate_related_items').click(function(e){
    e.preventDefault();

    maxH += 352;

    $('.ingridients-related-item').css('max-height', maxH);
    if(maxH > $(".ingridients-related-item").height() ) {
      $(this).hide();
    }
  });
  	

  //   ACCOUNT TOGGLE RESPONSIVE
  $('.logintab').click(function(e){
    if($(window).width() < 480) {
      e.preventDefault();
      //       $('#customer_login').toggle();
      //       $('#create_customer').hide();
      if(window.loginform !== 1){
        //$('.logintab').after($( "form#customer_login" ).clone().attr('id','customer_login2'));
        window.loginform = 1;
      }
      $('#customer_login2').toggle();
    }

  });

  $('.panel-group-a').click(function(e){
    e.preventDefault();
    var $this = $(this),
        panelSub = $this.siblings('.panel-subtitle');
    panelSub.slideToggle()
  });

// SIGN UP TAB RESPONSIVE TOGGLE
  $('.signuptab').click(function(e){
    if($(window).width() < 480) {
      e.preventDefault();
      console.log("signup form trigger")
      $('#create_customer').toggle();
    } else {
      e.preventDefault();
    	$('form#customer_login').hide();
    	$('#create_customer').show();
    }
  });

  // SUB NAVIGATION BACK
  $('.sub-nav-back').click(function(e){
    e.preventDefault();
    var $this = $('.active-sub');
    $this
    .children().removeClass().addClass("active-sub-a")
    .parent().toggleClass("not-active-sub").removeClass("active-sub")
    .parent('ul.h-sub-nav').toggleClass("notactive").removeClass("active")

  });


  var windowWidth = $(window).width();

  if(windowWidth <= 768){
    $('.leftfoldernavigation').click(function(e){
      $('.content-sub-nav').toggle();
    });
  }


  //   MOBILE SEARCH
  $('.icon-search').click(function(e){
    if($(window).width() < 835) {
      e.preventDefault();
      $('.hdr-search-mobile').slideToggle();
    }
  });

  //ADDRESS ACCOUNT PAGE

  $('.address-dd').click(function(e){
    $('#newAddressForm').slideToggle();
  });

  $('.address-edit-toggle').click(function(e){
    var $this = $(this),
        $thisParent = $(this).closest('div.address');

    $thisParent.next().slideToggle();

  });

  //   ACCOUNT ORDERS

  $('.li-si-desc').click(function(e){
    $('.primary-content').hide();
    $('.orders-acc').show();
  });
  
  $('.dp-list-order').click(function(e){
    $('.primary-content').hide();
    $('.orders-acc').show();
  });


  // DELETE ACCOUNT ADDRESS
  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');

    // eslint-disable-next-line no-alert
    if (
      confirm(
        confirmMessage || 'Are you sure you wish to delete this address?'
      )
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      });
    }
  });
  
//   SIZE PRODUCTPAGE TOGGLE
  $('#lush-icon-pl-arrowdown').click(function(e){
  	
  });
  
  
  //   NUMBER OF REVIEWS PRODUCTS ITEM
  var countStar = $('.jdgm-rev-widg').data('number-of-reviews');
  
  if (countStar == 0){
     $('.page-container .count-rev').append('<span>No reviews yet</span>');
  } else {
	$('.page-container .count-rev').append('<span>'+ countStar +'  '+ '</span>'+'<span>Review</span>');
  };
  
  //   NUMBER OF STARS PRODUCT ITEM
  var starCount = 0;
  var starCount = $('.jdgm-rev-widg').data('average-rating');
  
  if (starCount == undefined ){
   $('.jdgm-rev-widg__summary-stars.stars a').addClass('jdgm--off');
  } else if (starCount < 1 ){
    $('.jdgm-rev-widg__summary-stars.stars a').addClass('jdgm--off');
  } else if(starCount < 2){
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(1)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(2)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(3)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(4)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(5)').addClass('jdgm--off');
  } else if(starCount < 3){
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(1)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(2)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(3)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(4)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(5)').addClass('jdgm--off');
  } else if(starCount < 4){
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(1)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(2)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(3)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(4)').addClass('jdgm--off');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(5)').addClass('jdgm--off');
  } else if(starCount < 5){
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(1)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(2)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(3)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(4)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(5)').addClass('jdgm--off');
  } else {
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(1)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(2)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(3)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(4)').addClass('jdgm--on');
    $('.jdgm-rev-widg__summary-stars.stars a:nth-child(5)').addClass('jdgm--on');
  };
  
  
  
//   MAIL CHIMP FOOTER
  
  $('.unique-chimp-redirect1').submit(function(e){
    e.preventDefault();
    var $this = $(this),
        emailText = $this.find('#maillistinput-footer'),
        mailChimp = $('#mc_embed_signup'),
        mailInput = mailChimp.find('#mce-EMAIL'),
        mailForm = mailChimp.find('#mc-embedded-subscribe-form'),
        mailCheck = '',
        
    testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

    if(testEmail.test(emailText.val())){
      mailInput.val(emailText.val());
      mailForm.submit();
    } 
    else {
      e.preventDefault();
      alert('Please input email');
    }

  });
  
	
    $('.unique-chimp-redirect2').submit(function(e){
      e.preventDefault();
      var $this = $(this),
          emailText = $this.find('#ltkmodal-email'),
          mailChimp = $('#mc_embed_signup'),
          mailInput = mailChimp.find('#mce-EMAIL'),
          mailForm = mailChimp.find('#mc-embedded-subscribe-form'),
          mailCheck = '',
          testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;


      if(testEmail.test(emailText.val())){
        mailInput.val(emailText.val());
        mailForm.submit();
      } 

      else {
        e.preventDefault();
        alert('Please input email');
      }

    });
  



  // CART SLICK

    $('.slick-slider-lush').slick({
      dots: false ,
      infinite: false,
      speed: 300,
      arrow: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      varWidth: true,

      responsive: [
        { 
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 834,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  
//   PRODUCT SLICK
//     $('.product-slick-slider').slick({
//     dots: false ,
//     infinite: false,
//     speed: 300,
//     arrow: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     prevArrow: $('.slick-prev'),
//     nextArrow: $('.slick-next'),
//     varWidth: true,

//     responsive: [
//       { 
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true
//         }
//       },
//       {
//         breakpoint: 834,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ]
//   });
  
  

  $('.ymal-slider').slick({
    dots: false ,
    infinite: false,
    speed: 300,
    arrow: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    varWidth: true,
    useTransform: false,
    responsive: [
      { 
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
//   var elem = document.querySelector('.content-wrapper.related-prod');
//   var flkty = new Flickity( elem, {
//     // options
//     cellAlign: 'left',
//     contain: true,
//     pageDots: false,
//     prevNextButtons: false
//   });
  
  

  
  
  
  //   EMAIL POP-UP OVERLAY
  $('#modal-email-close').click(function(e){
    $('.modal-overlay-email').hide();
  });
  
  // CLICK AND COLLECT DISABLE SHIPPING
  if($('body').hasClass('template-cart')){
    setTimeout(function(){
      $('.omni-checkoutMethodName:contains("Shipping")').parent().hide();
    },1000)
  }


  //   INCREMENT PRODUCT QUANTITY
  $('.plus').click(function(){
    $('.cart-quantity').get(0).value++;
  });
  //   DECREMENT PRODUCT QUANTITY
  $('.minus').click(function(){
    $('.cart-quantity').get(0).value--;
  });
  
  $('.unique-update').change(function(e){
  var $this = $(this),
      $value = $this.val(),
      $inventory = $this.siblings('.item-variant-inventory').data('cartqtyinventory');
    if($value > $inventory ){
      $('.cart__submit-control').click(function(e){
        e.preventDefault();
      	$('.fancybox-overlay').show();
        $('.fancybox-item').click(function(){
          window.location.reload();
        });
      });
    } else{
      $('.cart__submit-control').submit();   
    }
  });

  //PRODUCT INSERT STORY

  $('#adbox-image').insertAfter($('.content-wrapper').children().eq(0));

  // ajax add to cart
//   $('#cta-add-to-cart').on('click', function(e){
//     e.preventDefault();

//     var $form = $(this).closest('form');
//     var $quantity = $form.find('input[name="quantity"]').val();
//     var $id = $form.find('button[name="id"]').val();
//     var $viewcheckout = $form.closest('#PageContainer').siblings('#shopify-section-lush-header').find('.unique-collect-in-store').attr('data-colstore');
//     $.ajax({
//       method: 'POST',
//       url: '/cart/add',
//       data: {
//         quantity: $quantity,
//         id: $id
//       },
//       success: function(data){
//         var $cartData = $('<div>'+data+'</div>');
//         var qty = $cartData.find('#basket-qty').text();
//         var $basketcount = $('#basket-qty');
//         if($basketcount.length){
//           $basketcount.text(qty);
//         } else {
//           $('.mini-cart-total > a').append('<span id="basket-qty">'+qty+'</span>');
//         }

//         var $minicartItems = $cartData.find('#ajax-minicart-items').children('.mini-cart-products');
//         $('#minicart-items').children().remove();
//         $minicartItems.each(function(i,e){
//           $('#minicart-items').append($(e));
//         });
//         $('.mini-cart-totals p > span').text($cartData.find('#ajax-minicart-items').find('.subtotal').text());
//         $('.addtocart-overlay').show();
//         setTimeout(function(){
//             window.location.reload();
//         }, 1000);
      
//       },
//       error: function(data){
//         $('.fancybox-overlay').show();
//       } 
//     }); 
//     $('.mini-cart-content').hide();
//     $('.cart').hide();

//   });
  
//   PROBLEM TO SOLVE ADD TO CART
//     var nosizeoption = $('.variant-inventory').data('firstqty'),
//         nosizeid = $('.variant-inventory').data('firstitemid'),
//         nosizecartqty = $('#minicart-items').children('.mini-cart-products[data-incartid="'+nosizeid+'"]').data('incart');
  
// 		nosizecartqty = (isNaN(nosizecartqty) ? 0 : nosizecartqty);
  
//   	var nosizetotal = nosizeoption - nosizecartqty;
  
//     var firstId = $('.size-select option:selected').data('mainid'),
//         firstQty = $('#minicart-items').children('.mini-cart-products[data-incartid="'+firstId+'"]').data('incart');
//     	firstQty = (isNaN(firstQty) ? 0 : firstQty);
  
//    	var total = nosizeoption - firstQty;
          
//       $('#unique-cart-btn').click(function(e){
//         var $this = $(this);
//         if($this.hasClass('btn-cart-disabled')){
          
//           e.preventDefault();
//           $('.fancybox-overlay').show();
          
//         } else {
//           e.preventDefault();

//           var $form = $(this).closest('form');
//           var $quantity = $form.find('input[name="quantity"]').val();
//           var $id = $form.find('button[name="id"]').val();
//           var $viewcheckout = $form.closest('#PageContainer').siblings('#shopify-section-lush-header').find('.unique-collect-in-store').attr('data-colstore');
//           $.ajax({
//             method: 'POST',
//             url: '/cart/add',
//             data: {
//               quantity: $quantity,
//               id: $id
//             },
//             success: function(data){
//               var $cartData = $('<div>'+data+'</div>');
//               var qty = $cartData.find('#basket-qty').text();
//               var $basketcount = $('#basket-qty');
//               if($basketcount.length){
//                 $basketcount.text(qty);
//               } else {
//                 $('.mini-cart-total > a').append('<span id="basket-qty">'+qty+'</span>');
//               }

//               var $minicartItems = $cartData.find('#ajax-minicart-items').children('.mini-cart-products');
//               $('#minicart-items').children().remove();
//               $minicartItems.each(function(i,e){
//                 $('#minicart-items').append($(e));
//               });
//               $('.mini-cart-totals p > span').text($cartData.find('#ajax-minicart-items').find('.subtotal').text());
//               $('.addtocart-overlay').show();
//               setTimeout(function(){
//                 window.location.reload();
//               }, 1000);

//             },
//             error: function(data){
//               $('.fancybox-overlay').show();
//             } 
//           }); 
//           $('.mini-cart-content').hide();
//           $('.cart').hide();
          
//         }
//       });
    
  
//   PROBLEM TO BE SOLVE WHEN HAVE SELECT OPTION

//     $('.size-select').on("change",function(){
//       var $this = $(this);
//       var dataprice = $("select option:selected").attr('data-price'),
//           datacompareprice = $("select option:selected").attr('data-compareprice'),
//           varId = $("select option:selected").val();
//       $("#unique-cart-btn").val(varId)


//       if(datacompareprice != ''){
//         $(".price-field.regprice").text(dataprice).append(' PHP').css("color","red");
//         $(".price-field.compare").text(datacompareprice).append(' PHP');
//       }else{
//         $(".price-field.regprice").text(dataprice).append(' PHP').css("color","black");
//         $(".price-field.compare").text(datacompareprice);
//       }

//       var stockQty1 = $("select option:selected").attr('data-stockqty');
//       var stockId = $("select option:selected").data('mainid');
//       var cartQty = $('#minicart-items').children('.mini-cart-products[data-incartid="'+stockId+'"]').data('incart');

//       cartQty = (isNaN(cartQty) ? 0 : cartQty);

//       var alltags = $('select option:selected').data('ptags');
//       if(alltags.includes("Fast Moving")){
//         var alltotal = stockQty1 - cartQty;

//         if( alltotal <= 4 ){

//           $('#unique-cart-btn').addClass('btn-cart-disabled');

//         }else{

//           $('#unique-cart-btn').removeClass('btn-cart-disabled');

//         }
//       }else{
//         var alltotal = stockQty1 - cartQty;

//         if( alltotal <= 2 ){

//           $('#unique-cart-btn').addClass('btn-cart-disabled');

//         }else{

//           $('#unique-cart-btn').removeClass('btn-cart-disabled');

//         }
//       }

//     });


  
  
  //   PRODUCT PAGE OUT OF STOCK
  $('.fancybox-close').click(function(e){
    $('.fancybox-overlay').hide();
  });

  
  //   SCROLL TO TOP
  if ($(window).width() > 320) {
    
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 800) {
        $('.scrolltop-site-notice').fadeIn();
      } else {
        $('.scrolltop-site-notice').fadeOut();
      }
    });  
  }
  
  
  var scrollLink = $('.scroll');
  // Smooth scrolling
  scrollLink.click(function(e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: $(this.hash).offset().top
    }, 2000 );
  });

  // Active link switching
  $(window).scroll(function() {
    var scrollbarLocation = $(this).scrollTop();

    scrollLink.each(function() {

      var sectionOffset = $(this.hash).offset().top - 20;

      if ( sectionOffset <= scrollbarLocation ) {
        $(this).parent().addClass('active');
        $(this).parent().siblings().removeClass('active');
      }
    })

  })
  



  //   jerry js
  //   focus input

  $('#FirstName').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-1').removeClass('show');
      $('.input-form .design').removeClass('color-active');
      $('.input-form .design').addClass('color-change');
    }
    else{
      $('.error-1').addClass('show');
      $('.input-form .design').addClass('color-active');
      $('.input-form .design').removeClass('color-change');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.input-form .design').addClass('color-change');
        $('.error-1').removeClass('show');
        $('.input-form .design').removeClass('color-active');
      }
      else{

        $('.error-1').addClass('show');
        $('.input-form .design').removeClass('color-change');
        $('.input-form .design').addClass('color-active');

      }
    });   
  });
  //   last name
  $('#LastName').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-2').removeClass('show');
      $('.input-form .design-2').removeClass('color-active-2');
      $('.input-form .design-2').addClass('color-change-2');

    }
    else{
      $('.error-2').addClass('show');
      $('.input-form .design-2').removeClass('color-change-2');
      $('.input-form .design-2').addClass('color-active-2');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-2').removeClass('show');
        $('.input-form .design-2').addClass('color-change-2');
        $('.input-form .design-2').removeClass('color-active-2');
      }
      else{

        $('.error-2').addClass('show');
        $('.input-form .design-2').removeClass('color-change-2');
        $('.input-form .design-2').addClass('color-active-2');
      }
    });   
  });
  //   telephone 
  
  
  $('#tel').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-3').removeClass('show');
      $('.input-form .design-3').addClass('color-change-3');
      $('.input-form .design-3').removeClass('color-active-3');

    }
    else{
      $('.error-3').addClass('show');
      $('.input-form .design-3').removeClass('color-change-3');
      $('.input-form .design-3').addClass('color-active-3');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-3').removeClass('show');
        $('.input-form .design-3').addClass('color-change-3');
        $('.input-form .design-3').removeClass('color-active-3');
      }
      else{

        $('.error-3').addClass('show');
        $('.input-form .design-3').removeClass('color-change-3');
        $('.input-form .design-3').addClass('color-active-3');
      }
    });   
  });

  //     email
  $('#Email').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-4').removeClass('show');
      $('.input-form .design-4').addClass('color-change-4');
      $('.input-form .design-4').removeClass('color-active-4');

    }
    else{
      $('.error-4').addClass('show');
      $('.input-form .design-4').removeClass('color-change-4');
      $('.input-form .design-4').addClass('color-active-4');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-4').removeClass('show');
        $('.input-form .design-4').addClass('color-change-4');
        $('.input-form .design-4').removeClass('color-active-4');
      }
      else{

        $('.error-4').addClass('show');
        $('.input-form .design-4').removeClass('color-change-4');
        $('.input-form .design-4').addClass('color-active-4');
      }
    });   
  });
  //   confirmation email
  $('#confirm-email').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-5').removeClass('show');
      $('.input-form .design-5').addClass('color-change-5');
      $('.input-form .design-5').removeClass('color-active-5');

    }
    else{
      $('.error-5').addClass('show');
      $('.input-form .design-5').removeClass('color-change-5');
      $('.input-form .design-5').addClass('color-active-5');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-5').removeClass('show');
        $('.input-form .design-5').addClass('color-change-5');
        $('.input-form .design-5').removeClass('color-active-5');
      }
      else{

        $('.error-5').addClass('show');
        $('.input-form .design-5').removeClass('color-change-5');
        $('.input-form .design-5').addClass('color-active-5');
      }
    });   
  });

  //   password
  $('#CreatePassword').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-6').removeClass('show');
      $('.input-form .design-6').addClass('color-change-6');
      $('.input-form .design-6').removeClass('color-active-6');

    }
    else{
      $('.error-6').addClass('show');
      $('.input-form .design-6').removeClass('color-change-6');
      $('.input-form .design-6').addClass('color-active-6');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-6').removeClass('show');
        $('.input-form .design-6').addClass('color-change-6');
        $('.input-form .design-6').removeClass('color-active-6');
      }
      else{

        $('.error-6').addClass('show');
        $('.input-form .design-6').removeClass('color-change-6')
        $('.input-form .design-6').addClass('color-active-6');
      }
    });   
  });
  //   confirm password
  $('#pass-verify').focus(function(e){
    var $this = $(this);
    if($this.val() !== ''){
      $('.error-7').removeClass('show');
      $('.input-form .design-7').addClass('color-change-7');
      $('.input-form .design-7').removeClass('color-active-7');

    }
    else{
      $('.error-7').addClass('show');
      $('.input-form .design-7').removeClass('color-change-7')
      $('.input-form .design-7').addClass('color-active-7');
    }
    $this.on("change",function(e){
      var $this = $(this);
      if($this.val() !== ''){
        $('.error-7').removeClass('show');
        $('.input-form .design-7').addClass('color-change-7');
        $('.input-form .design-7').removeClass('color-active-7');
      }
      else{

        $('.error-7').addClass('show');
        $('.input-form .design-7').removeClass('color-change-7')
        $('.input-form .design-7').addClass('color-active-7');
      }
    });   
  });
  // //   validation of email address
  //   function valemail(){
  //             var pattern = /^([A-Za-z0-9_\-\.]){1,}\@([A-Za-z0-9_\-\.]){1,}\.([A-Za-z]){2,4}$/;
  //             var address = $('#Email').val(),
  //                 confirmAddr = $('#confirm-email').val();
  //             if(pattern.test(address)){
  //               e.preventDefault();
  //                   $('#error-match-2').text('Enter a  valid email').show();
  //             }
  //     		else if(pattern.test(confirmAddr)){
  //               	e.preventDefault();
  //                $('#error-match-2').text('Enter a  valid email').show();
  //     		}

  //   }
  $('#error-match').hide();
  var hey = $('input[type=checkbox]').attr('checked');

  $('input[type=checkbox]').click(function(){
    var $this = $(this);
  });
  
  $('#create_customer').submit(function(e){

    //  verify  password 
    var $this = $(this),
        firstpass = $this.find('#CreatePassword'),
        secondpass = $this.find('#pass-verify'),
        confirmEmail = $this.find('#confirm-email'),
        addr = $this.find('#Email'),
        tel = $this.find('#tel'),
        fname = $this.find('#FirstName'),
        lname = $this.find('#LastName'),
        letter = /[a-z]/,
        upper  =/[A-Z]/,
        number = /[0-9]/,
        characters = /[!@#$%^&*(),.?":{}|<>]/
    if( !number.test(tel.val())){
      e.preventDefault();
      $('#error-match-3').text('Enter valid number').show();

    }
    else if(addr.val() != confirmEmail.val()){
      e.preventDefault();
      $('#error-match-2').text('Email address did not match').show();
    }
    else if(firstpass.val() != secondpass.val()){
      e.preventDefault();
      $('#error-match').text('Password validation did not match.').show();

    }
    else if( firstpass.val().length < 8 || secondpass.val().length < 8 ){
      e.preventDefault();
      $('#error-match').text('Password must be atleast 8 characters long.').show();
    }
    else if( !letter.test(firstpass.val()) || !letter.test(secondpass.val()) ) {
      e.preventDefault();
      $('#error-match').text('Password must have at least 1 lowercase letter.').show();
    }
    else if( !upper.test(firstpass.val()) || !upper.test(secondpass.val()) ) {
      e.preventDefault();
      $('#error-match').text('Password must have at least 1 uppercase letter.').show();
    }
    else if( !number.test(firstpass.val()) || !number.test(secondpass.val()) ) {
      e.preventDefault();
      $('#error-match').text('Password must have at least 1 number.').show();
    }
    else if( !characters.test(firstpass.val()) || !characters.test(secondpass.val()) ) {
      e.preventDefault();
      $('#error-match').text('Password must have at least one special character - ! @ # $ % ^ & * ( ) _ +.').show();
    }
//     else if($("#check-box:checked").length == 0){
//       e.preventDefault();
//       alert("Please check the checkbox");
//     }
    else{
      $('#error-match').hide();
    };
    
    if(addr.val() == confirmEmail.val()){
      $('#error-match-2').text('Email address did not match').hide();
    }
    
    if( number.test(tel.val())){
      $('#error-match-3').text('Enter valid number').hide();
    }


  });
  
  $('#notice-cookie-block .button').click(function(e){
  	$('#notice-cookie-block').fadeOut();
    createCookie('cookieopted', '1', 1);
    
  });
  
//   RESET PASS CONFIFRMATION
  
  $('.btn-res-sbmt').click(function(e){
    e.preventDefault();
    var $this = $(this);
    $('.resetpass').show();
    setTimeout(function(){
     $this.closest('form').submit();
    }, 2000);
    
  });
  
  $('.uniq-btn-fp').click(function(e){
    $('.resetpass').show();
    $('.modal-overlay').hide();
    var $this = $(this);
    setTimeout(function(){
      $this.closest('form').submit();
    }, 2000);
  });
  
  
//   CART QTY SELECT
  
//   $('.quantity-selector').change(function(e){
//     var $this = $(this),
//         $value = $this.children("option:selected").val(),
//         $qtyData = $this.closest('.quantity-cartlist').find('.unique-update'),
//         $stock = $this.closest('.quantity-cartlist').find('.item-variant-inventory').val(),
//         $minusStock = 2,
//         $onlyStock = $stock - $minusStock;

//     if($value > parseInt($onlyStock)){
//       $('.fancybox-overlay').show();
//       e.target.selectedIndex = 0;

//     } else{
//       $qtyData.val($value);
//       $this.siblings('.update-action').trigger('click');
//     }

//   });
  
    $('.quantity-selector').change(function(e){
      var $this = $(this),
          $value = $this.children("option:selected").val(),
          $qtyData = $this.closest('.quantity-cartlist').find('.unique-update'),
          $stock = $this.closest('.quantity-cartlist').find('.item-variant-inventory').val();
      //           $minusStock = 2,
      //           $onlyStock = $stock - $minusStock;

      if($this.closest('.quantity-cartlist').hasClass('with-oe')){
        var $minusStock = 1;
      }else if($this.closest('.quantity-cartlist').hasClass('with-fm')){
      	var $minusStock = 4;
      }else{
        var $minusStock = 2;   
      }
      var $onlyStock = $stock - $minusStock;
		
      if($value > parseInt($onlyStock)){
        $('.fancybox-overlay').show();
        e.target.selectedIndex = 0;

      } else{
        $qtyData.val($value);
        $this.siblings('.update-action').trigger('click');
      }

    });
  
  
//  EDIT ADDRESS  REQUIRED FIELDS

  
  $('.update-edit-address').click(function(e){
  	e.preventDefault();
    var $this = $(this),
		$form = $this.closest('form'),
        fname = $form.find('.edit-fname-input'),
        lname = $form.find('.edit-lname-input'),
        add1 = $form.find('.edit-add1-input'),
        province = $form.find('#province-copy option:selected'),
        city = $form.find('#city-copy option:selected'),
        zip = $form.find('.edit-zip-input'),
        pn = $form.find('.edit-cp-input'),
        number = /[0-9]/;
    
    
    if(fname.val() == '' ){
    	fname.siblings('.error-1').show();
    }else if(lname.val() == ''){
    	lname.siblings('.error-1').show();
    }else if(add1.val() == ''){
    	add1.siblings('.error-1').show();
    }else if(province.val() == 'Select Province' ){
      province.closest('.grid__item').children('.error-1').show();
    }else if(city.val() == 'Select City / Municipality' ){
    	city.closest('.grid__item').children('.error-1').show();
    }else if(!number.test(zip.val())){
      zip.closest('.grid__item').children('.error-1').show();
    }else if(!number.test(pn.val())){
      pn.closest('.grid__item').children('.error-1').show();
    }else{
      $form.submit();
    }


    
    if(fname.val() != '' ){
    	fname.siblings('.error-1').hide();
    }
    if(lname.val() != ''){
    	lname.siblings('.error-1').hide();
    }
    if(add1.val() != ''){
      add1.siblings('.error-1').hide();
    }
    if(province.val() != 'Select Province' ){
      province.closest('.grid__item').children('.error-1').hide();
    }
    if(city.val() != 'Select City / Municipality' ){
    	city.closest('.grid__item').children('.error-1').hide();
    }
    if(number.test(zip.val())){
      zip.closest('.grid__item').children('.error-1').hide();
    }
    if(number.test(pn.val())){
      pn.closest('.grid__item').children('.error-1').hide();
    }
    
    
  
  })
  

//   ADD ADDRESS REQUIRED FIELDS
  $('.add-new-addr-btn').click(function(e){
    e.preventDefault();
    var $this = $(this),
        $form = $this.closest('form'),
        fname = $form.find('.add-fname-input'),
        lname = $form.find('.add-lname-input'),
        add1 = $form.find('.add-add1-input'),
        province = $form.find('#province option:selected'),
        city = $form.find('#city option:selected'),
        zip = $form.find('.add-zip-input'),
        pn = $form.find('.add-pn-input'),
        number = /[0-9]/;
    
    
    if(fname.val() == '' ){
      fname.siblings('.error-1').show();
    }else if(lname.val() == ''){
      lname.siblings('.error-1').show();
    }else if(add1.val() == ''){
      add1.siblings('.error-1').show();
    }else if(province.val() == 'Select Province' ){
      province.closest('.formField').children('.error-1').show();
    }else if(city.val() == 'Select City / Municipality' ){
      city.closest('.formField').children('.error-1').show();
    }else if(!number.test(zip.val())){
      zip.closest('.formField').children('.error-1').show();
    }else if(!number.test(pn.val())){
      pn.closest('.formField').children('.error-1').show();
    }else{
      $form.submit();
    }
    
    
    
    if(fname.val() != '' ){
      fname.siblings('.error-1').hide();
    }
    if(lname.val() != ''){
      lname.siblings('.error-1').hide();
    }
    if(add1.val() != ''){
      add1.siblings('.error-1').hide();
    }
    if(province.val() != 'Select Province' ){
      province.closest('.formField').children('.error-1').hide();
    }
    if(city.val() != 'Select City / Municipality' ){
      city.closest('.formField').children('.error-1').hide();
    }
    if(number.test(zip.val())){
      zip.closest('.formField').children('.error-1').hide();
    }
    if(number.test(pn.val())){
      pn.closest('.formField').children('.error-1').hide();
    }
    
  })

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/;domain=" + document.domain + "";
  }


  

  function processCookieLaw(cookieLawData) {
    if (isValueValid(cookieLawData)) { $('#cookiebar').hide(); } else { $('#cookiebar').show(); }
  }

  function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
  }

  //   COOKIES FOR EMAIL POP-UP

  var isFirstVisit = getCookie('firstvisit');    
  if (isFirstVisit == null ) {
    createCookie('firstvisit', '1', 30);
    setTimeout(function(){
      $('.modal-overlay-email').show();
    },2000);
  } else {
    $('.modal-overlay-email').hide();
  }
  

  var optedIn = getCookie('cookieopted');  
  if (optedIn == null ) {
    setTimeout(function(){
       $("#notice-cookie-block").show();
    },2000);
  }
  
  

  //   var firstVisit = Cookies.get('first_visit');

  //   if(firstVisit !== 'false'){
  //     // execute function for first visit
  //     $('.modal-overlay-email').show();
  //     // show modal

  //     // set cookie
  //     Cookies.set('first_visit', 'false', { expires: 1 });
  //   } else {
  //     // dahil not first visit
  //     $('.modal-overlay-email').hide();
  //     // don't show modal

  //   }




});

// window.onload = function() {	
// 	// ---------------
// 	// basic usage
// 	// ---------------
// 	var $ = new City();
// 	$.showProvinces("#province");
// 	$.showCities("#city");
  
//   	$.showProvinces("#province-copy")
//     $.showCities("#city-copy")
// 	// ------------------
// 	// additional methods 
// 	// -------------------
// 	// will return all provinces 
// // 	console.log($.getProvinces());
	
// // 	// will return all cities 
// // 	console.log($.getAllCities());
	
// // 	// will return all cities under specific province (e.g Batangas)
// // 	console.log($.getCities("Batangas"));	
	
// }

// =====for comment section======

$(document).ready(function(){
  $("#button_comment").click(function(){
    $("#hidden_form_panel").slideToggle("slow");
    $("#button_comment").hide();
  });
  
  $("#comm_cancel").click(function(){
    $("#hidden_form_panel").slideToggle();
    $("#button_comment").show();
  });
});


var gift = window.giftitem || {};
for (var i = 0; i < gift.length; i++) {
  jQuery.getJSON('/products/'+gift[i].handle+'.js', function(product) {
    var variants = product.variants[0].option1;


    $.ajax({
      type: "get",
      url: ('/products/'+product.handle+ '?view=metajson'),
      success: function (data) {
        
        var pTags = '';
        var gsUrl = ''
        if(product.tags.includes('Gift Set Exclusive')){
          pTags = '<div class="prod-gift-exc">'+
            '<div class="prod-badge_bkg"></div>'+
            '<div class="prod-badge-text nofocus" style="outline: none; margin: 10px 0;">not sold separately</div>'+
            '</div>'
          gsUrl = '<img src="'+product.images+'" class="gift-main-img" alt="" title="" >'
 
        }else{
          gsUrl = '<a href="'+product.url+'">'+
            '<img src="'+product.images+'" class="gift-main-img" alt="" title="" >'+
            '</a>'
        }
        
        $('.gift-items-wrapper').append('<div class="gift-items-content">' +
                                        '<div class="gift-image-holder" tabindex="0">'+
                                        gsUrl+
                                      	pTags +
                                        '</div>'+
                                        '<div class="gift-content-holder">'+
                                        '<div class="gift-content-title">'+ product.title + '</div>' +
                                        '<div class="gift-ptype">'+product.type+'</div>'+
                                        '<div class="gift-tilesize">'+variants+'</div>'+
                                        '<div class="gift-item-description">'+ data + '</div>' +
                                        '<div class="gift-ratings"></div>'+
                                        '</div>'+
                                        '</div>');
      }
    });
  });
}


function numbersonly(myfield, e)
{
  var key;
  var keychar;

  if (window.event)
    key = window.event.keyCode;
  else if (e)
    key = e.which;
  else
    return true;

  keychar = String.fromCharCode(key);

  // control keys
  if ((key==null) || (key==0) || (key==8) || (key==9) || (key==13) || (key==27) )
    return true;

  // numbers
  else if ((("0123456789").indexOf(keychar) > -1))
    return true;

  // only one decimal point
  else if ((keychar == "."))
  {
    if (myfield.value.indexOf(keychar) > -1)
      return false;
  }
  else
    return false;
}